import React, { FC, useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { OptionInternal, OptionSource } from '../../../../shared/options';
import { OptionEditor } from '../../../components/OptionEditor';
import { useTranslation } from '../../../translations';
import { captureError } from '../../../utils/errorHandling';

interface CreateOptionProps {
  readonly source: OptionSource;
  readonly onCreate: (option: OptionInternal) => void;
}

export const CreateOption: FC<CreateOptionProps> = ({ source, onCreate }) => {
  const { ts } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [option, setOption] = useState<OptionInternal>({
    id: 0,
    max: null,
    min: 0,
    name: '',
    type: 'text',
    description: '',
    displayOnCashier: false,
    source,
    selectValues: [],
  });

  const create = useCallback(async () => {
    try {
      const newOption = await api.createOption(source, {
        name: option.name,
        description: option.description || '',
        max: option.max,
        min: option.min,
        type: option.type,
        selectValues: option.selectValues,
        displayOnCashier: option.displayOnCashier,
        style: option.style,
        source,
      });

      onCreate(newOption);
      toast.success(ts('new_option_has_been_created'));
    } catch (error) {
      captureError(error as Error);
    }
  }, [option, source, onCreate, ts]);

  return (
    <Card id="newOptionForm">
      <CardBody>
        <h5>{ts('creating_option')}</h5>
        <hr />
        <OptionEditor option={option} setIsEditing={setIsEditing} setOption={setOption} />
        <Row>
          <Col xs={12}>
            <Button block color="primary" disabled={isEditing} id="submitOption" onClick={create}>
              {ts('common.create')}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
